import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "max-w-screen-sm mx-auto min-h-screen w-full" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center bg-[url(/img/bg.jpg)] z-10 h-full relative overflow-hidden" }
const _hoisted_3 = { class: "h-screen w-screen overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 bg-red-600/50 backdrop-blur-sm flex flex-col items-center justify-center overflow-hidden"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "bg-[url(/img/bg.jpg)] min-h-screen px-4 sm:px-10 text-center flex flex-col items-center pt-4 gap-4 pb-10" }
const _hoisted_7 = { class: "bg-white border-4 border-b-[0.5rem] border-red-700 px-4 sm:px-8 py-4 sm:py-10 rounded-lg flex flex-col justify-center items-center -rotate-3 mt-4 sm:mt-10" }
const _hoisted_8 = {
  id: "",
  class: "relative bg-[url(/img/bg.jpg)] min-h-screen"
}
const _hoisted_9 = { class: "flex flex-col h-full" }
const _hoisted_10 = { class: "pt-4 sm:pt-8 pb-4 flex flex-col items-center justify-center" }
const _hoisted_11 = { class: "text-xl sm:text-5xl text-red-700 font-bold text-center inset-x-0 z-20" }
const _hoisted_12 = { class: "flex grow shrink-0" }
const _hoisted_13 = {
  class: "shrink-0 relative min-h-16 sm:min-h-32 rounded-lg overflow-hidden border-4 border-red-800",
  style: {"width":"50%"}
}
const _hoisted_14 = { class: "py-4 sm:py-10 text-center px-2 sm:px-10 grow pb-24" }
const _hoisted_15 = { class: "grid grid-cols-4 lg:grid-cols-4 gap-2 sm:gap-4 mt-5 mb-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = {
  key: 0,
  class: "bg-[url(/img/bg.jpg)] h-screen px-2 sm:px-10 text-center flex flex-col items-center justify-center gap-4 text-red-900"
}
const _hoisted_19 = {
  key: 0,
  class: "font-bold text-3xl"
}
const _hoisted_20 = {
  key: 1,
  class: "font-bold text-3xl"
}
const _hoisted_21 = {
  key: 2,
  class: "font-bold text-3xl"
}
const _hoisted_22 = { class: "bg-red-700 h-screen relative px-4" }
const _hoisted_23 = { class: "absolute left-[20%] top-[32%] right-[20%] bottom-[10%] overflow-hidden" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "bg-red-600 min-h-screen flex flex-col items-center justify-center px-10 pt-4 gap-2 pb-32 overflow-hidden" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" First screen "),
    _withDirectives(_createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/0-cielo.webp)] landing", _ctx.loading <= 2 ? 'animate-parallax-1' : '-translate-y-full'])
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/1-calle.webp)] landing", _ctx.loading <= 2 ? 'animate-parallax-1' : '-translate-y-full']),
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/2-parque.webp)] landing", _ctx.loading <= 2 ? 'animate-parallax-1' : '-translate-y-full']),
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/3-casona.webp)] landing", _ctx.loading <= 1 ? ' animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/4-capilla.webp)] landing", _ctx.loading <= 1 ? ' animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/5-palmeras.webp)] landing", _ctx.loading <= 1 ? ' animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/6-luces.webp)] landing", _ctx.loading <= 1 ? ' animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/7-carros.webp)] landing", _ctx.loading <= 1 ? 'animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[6] || (_cache[6] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/8-pileta.webp)] landing", _ctx.loading <= 1 ? 'animate-parallax-2' : '-translate-y-full']),
          onClick: _cache[7] || (_cache[7] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-[url(/img/landing/9-booth.webp)] landing", _ctx.loading <= 0 ? 'animate-parallax-3' : '-translate-y-full']),
          onClick: _cache[8] || (_cache[8] = $event => (_ctx.step++))
        }, null, 2 /* CLASS */),
        _cache[16] || (_cache[16] = _createElementVNode("img", {
          src: "/img/logo.png",
          alt: "",
          class: "absolute top-12 h-24 inset-x-0 mx-auto"
        }, null, -1 /* HOISTED */)),
        _cache[17] || (_cache[17] = _createElementVNode("video", {
          autoplay: "",
          playsinline: "",
          muted: "",
          src: "/img/video.mp4",
          class: "mix-blend-screen absolute top-1/3 animate-bounce inset-x-0 w-32 left-1/3"
        }, null, -1 /* HOISTED */))
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[18] || (_cache[18] = _createElementVNode("img", {
              src: "/img/loading-logo.png",
              alt: "Logo PhotoBooth",
              class: "h-1/2 origin-top animate-swing -mt-10"
            }, null, -1 /* HOISTED */)),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-white text-center grow flex flex-col items-center justify-center" }, [
              _createElementVNode("h2", { class: "text-4xl font-bold" }, "Cargando experiencia..."),
              _createElementVNode("p", { class: "text-xl mt-4" }, "Por favor espera unos segundos")
            ], -1 /* HOISTED */)),
            _createElementVNode("progress", {
              class: "w-1/2 mt-8 rounded-md [&::-webkit-progress-bar]:rounded-lg [&::-webkit-progress-value]:rounded-lg [&::-webkit-progress-bar]:bg-slate-300 [&::-webkit-progress-value]:bg-red-800 [&::-moz-progress-bar]:bg-red-800 [&::-webkit-progress-value]:transition-all [&::-webkit-progress-value]:duration-500",
              min: "0",
              max: "3",
              value: 3 - _ctx.loading
            }, null, 8 /* PROPS */, _hoisted_5),
            _createCommentVNode(" <img src=\"/img/wemake-badge.svg\" alt=\"Logo WM\" class=\"mt-32 h-16 bg-black rounded-lg mx-auto\"> "),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "grow" }, null, -1 /* HOISTED */))
          ]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.step == 0]
    ]),
    _createCommentVNode(" Instructions "),
    _withDirectives(_createElementVNode("section", _hoisted_6, [
      _cache[25] || (_cache[25] = _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-red-700 font-bold text-xl" }, "Bienvenido al"),
        _createElementVNode("img", {
          src: "/img/logo.png",
          alt: "",
          class: "mt-2 px-12 sm:px-4"
        })
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_7, [
        _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-xl font-bold" }, " ¿Te imaginas pasar un San Valentín especial? ", -1 /* HOISTED */)),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mt-4 text-sm" }, " ¡Es más fácil de lo que crees! Para esta experiencia solo necesitarás una foto tuya y una de tu pareja para teletransportarse a lugares únicos y llevarse un recuerdo inolvidable. ", -1 /* HOISTED */)),
        _cache[23] || (_cache[23] = _createElementVNode("p", { class: "mt-8 text-gray-600 text-xs" }, " No te preocupes, no guardaremos ninguna foto. Además, funciona incluso sin conexión. ", -1 /* HOISTED */)),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "grow" }, null, -1 /* HOISTED */)),
        _createElementVNode("button", {
          class: "btn btn-primary mt-4 w-full",
          onClick: _cache[9] || (_cache[9] = $event => (_ctx.step++))
        }, "Empezar")
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.step == 1]
    ]),
    _createCommentVNode(" Take pictures "),
    _withDirectives(_createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.text), 1 /* TEXT */),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex gap-4" }, [
            _createElementVNode("canvas", {
              id: "p1Canvas",
              class: "object-cover h-32 sm:h-48 w-24 rotate-6 drop-shadow-lg rounded-md bg-red-200 border-white border-2",
              width: "1080",
              height: "1080"
            }),
            _createElementVNode("canvas", {
              id: "p2Canvas",
              class: "object-cover h-32 sm:h-48 -rotate-12 w-24 right-1 drop-shadow-lg rounded-md bg-red-200 border-white border-2",
              width: "1080",
              height: "1080"
            })
          ], -1 /* HOISTED */)),
          (!_ctx.stream)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary mx-10 mt-5 w-1/2",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.startPhotoBooth()))
              }, "Abrir cámara"))
            : _createCommentVNode("v-if", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createCommentVNode(" left pane "),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "grow" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("canvas", {
              id: "localVideoCanvas",
              class: _normalizeClass(["absolute inset-0 w-full h-full object-cover bg-blue-500", _ctx.freeze ? 'opacity-50' : '']),
              width: "500",
              height: "750"
            }, null, 2 /* CLASS */),
            _cache[27] || (_cache[27] = _createElementVNode("video", {
              src: "",
              id: "localVideo",
              autoplay: "",
              playsinline: "",
              muted: "",
              class: "bg-red-800 h-2"
            }, null, -1 /* HOISTED */))
          ]),
          _createCommentVNode(" right pane "),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "grow" }, null, -1 /* HOISTED */))
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.stream]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("button", {
            onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.captureCanvas && _ctx.captureCanvas(...args))),
            class: "btn btn-primary w-3/4 mb-4"
          }, "Tomar foto", 512 /* NEED_PATCH */), [
            [_vShow, _ctx.stream]
          ]),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex gap-4 items-center px-10" }, [
            _createElementVNode("hr", { class: "h-px grow border-red-800" }),
            _createElementVNode("div", null, " o elige una foto "),
            _createElementVNode("hr", { class: "h-px grow border-red-800" })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.famous, (person) => {
              return (_openBlock(), _createElementBlock("button", {
                key: person.name,
                class: "btn btn-secondary px-1",
                onClick: $event => (_ctx.selectFamousPerson(person.img))
              }, [
                _createElementVNode("img", {
                  src: person.img,
                  alt: person.name,
                  class: "w-16 h-16 sm:h-20 sm:w-20 rounded-full object-cover mx-auto"
                }, null, 8 /* PROPS */, _hoisted_17)
              ], 8 /* PROPS */, _hoisted_16))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("button", {
              class: "btn btn-secondary col-span-4",
              onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.selectPictureFromGallery && _ctx.selectPictureFromGallery(...args)))
            }, "Sube una foto")
          ])
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.step == 2 || _ctx.step == 3 || _ctx.step == 4]
    ]),
    _createCommentVNode(" Processing... "),
    (_ctx.step == 5)
      ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
          (_ctx.processingStep == 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_19, " Teletransportando... "))
            : _createCommentVNode("v-if", true),
          (_ctx.processingStep == 1)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_20, " Colocando caritas... "))
            : _createCommentVNode("v-if", true),
          (_ctx.processingStep == 2)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_21, " Imprimiendo... "))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Printing "),
    _withDirectives(_createElementVNode("section", _hoisted_22, [
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "bg-[url(/img/printer.png)] h-full bg-center bg-contain bg-no-repeat mx-10" }, null, -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col py-[10%] bg-white rounded-lg shadow-xl absolute w-[30%] inset-x-0 mx-auto transition-all duration-500", _ctx.print ? 'translate-y-0': '-translate-y-[120%]'])
        }, _cache[31] || (_cache[31] = [
          _createElementVNode("div", {
            id: "photo_1",
            class: "bg-gray-800 w-full"
          }, null, -1 /* HOISTED */),
          _createElementVNode("div", {
            id: "photo_2",
            class: "bg-gray-800 w-full"
          }, null, -1 /* HOISTED */),
          _createElementVNode("div", {
            id: "photo_3",
            class: "bg-gray-800 w-full"
          }, null, -1 /* HOISTED */),
          _createElementVNode("div", {
            id: "photo_4",
            class: "bg-gray-800 w-full"
          }, null, -1 /* HOISTED */)
        ]), 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "btn btn-secondary inset-x-8 absolute bottom-24 py-2 text-xl",
          onClick: _cache[13] || (_cache[13] = $event => (_ctx.step++))
        }, " Ver fotos ")
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.step == 6]
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_25, [
      _createElementVNode("canvas", {
        id: "outputCanvas",
        class: _normalizeClass(["bg-black w-full rounded-lg", _ctx.step == 7 ? 'animate-sbinalla' : ''])
      }, null, 2 /* CLASS */),
      _createElementVNode("button", {
        class: "btn btn-primary w-full mt-4",
        onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.shareToIg && _ctx.shareToIg(...args)))
      }, "Compartir en IG"),
      _createElementVNode("button", {
        class: "btn btn-secondary w-full",
        onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.startOver && _ctx.startOver(...args)))
      }, "Volver a empezar"),
      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "grow" }, null, -1 /* HOISTED */))
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.step == 7]
    ])
  ]))
}